/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponsePagedResultDayOff } from '../../models/api-response-paged-result-day-off';
import { PagedRequestDayOff } from '../../models/paged-request-day-off';

export interface SearchDayOff$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
      body: PagedRequestDayOff
}

export function searchDayOff(http: HttpClient, rootUrl: string, params: SearchDayOff$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponsePagedResultDayOff>> {
  const rb = new RequestBuilder(rootUrl, searchDayOff.PATH, 'post');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponsePagedResultDayOff>;
    })
  );
}

searchDayOff.PATH = '/v1/api/ui/dayOff/search';
